'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('register-success', {
      url: '/register-success',
      template: '<register-success></register-success>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/register-success/register-success.routes.js